import { createContext, Dispatch, SetStateAction } from 'react';

export type ListContextValue = {
  updateListFn: (page: number, limit: number) => void;
  paginationInfo: {
    page: number;
    limit: number;
    totalPages: number;
    total: number;
  };
};

type ListContext = [
  ListContextValue,
  Dispatch<SetStateAction<ListContextValue>>,
];

export const ListContextDefaultValue = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars
  updateListFn: (page: number, limit: number): any => undefined,
  paginationInfo: {
    page: 1,
    limit: 10,
    totalPages: 0,
    total: 0,
  },
};

export const CreateListContext = createContext<ListContext>([
  ListContextDefaultValue,
  () => undefined,
]);
